import React, {useState,useEffect} from 'react'
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";


// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
display: flex;
justify-content: center;
align-items: center;
text-align: center;
`;

function BigLoaders(props) {
  // let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#ff9b04");


  useEffect(() => {
    
  }, [props.loads]);
  return (
    <div className="sweet-loading" style={{display: "inline"}}>
      <BeatLoader color={color} loading={props.loads} css={override} size={30} />
    </div>
  )
}

export default BigLoaders